
import {defineComponent, inject, PropType, ref} from "vue";
import DefListTile from "@/components/DefListTile.vue";
import GuideListTile from "@/components/GuideListTile.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "DefAndGuideList",
  components: {DefListTile, GuideListTile},
  setup(props) {
    const tabs = [
      {label: "Definitions", value: 0},
      {label: "Guidelines", value: 1},
    ]
    const activeTab = ref(0);
    const mapStore = useMapStore()
    return {
      mapStore,
      tabs,
      activeTab,
    }

  }
})
